import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import TractionPowerCalculator from '../components/tools/TractionPowerCalculator';

const TractionPowerPage = () => {
  return (
    <div className="min-h-screen" data-testid="traction-power-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="Traction Power Calculator"
        description="Estimate the traction force and power required at the wheels from vehicle speed, road gradient, acceleration, mass, aerodynamics, and rolling resistance."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="traction-power-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <TractionPowerCalculator />
          <ToolGuideCta guidePath="/tools/traction-power/guide" toolName="Traction Power Calculator" />
        </div>
      </section>
    </div>
  );
};

export default TractionPowerPage;
